import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const ShThreeForm = () => {
    const [entries, setEntries] = useState(() => {
        const saved = localStorage.getItem("sh3_register_data");
        return saved ? JSON.parse(saved) : [{ id: Date.now() }];
    });
console.log("sh3333==",entries)
    useEffect(() => {
        localStorage.setItem("sh3_register_data", JSON.stringify(entries));
    }, [entries]);

    const updateField = (id, field, value) => {
        setEntries(prev => prev.map(entry => 
            entry.id === id ? { ...entry, [field]: value } : entry
        ));
    };

    const addEntry = () => {
        setEntries([...entries, { id: Date.now() }]);
    };

    const deleteEntry = (id) => {
        if (entries.length > 1) {
            setEntries(entries.filter(e => e.id !== id));
        }
    };

    return (
        <div className="max-w-7xl mx-auto p-4 md:p-8 bg-slate-50 min-h-screen font-sans text-slate-800">
            {/* Header Section from Image */}
            <div className="bg-white border-b-4  p-8 mb-10 text-center shadow-sm rounded-t-lg">
                <h1 className="text-2xl font-black uppercase tracking-tight">Form No. SH - 3</h1>
                <h2 className="text-xl font-bold mt-1">Register of Sweat Equity Shares</h2>
                <p className="text-[10px] italic text-slate-500 mt-2 max-w-3xl mx-auto">
                    [Pursuant to section 54 of the Companies Act, 2013 and rule 8(14) of the Companies (Share Capital and Debentures) Rules 2014]
                </p>
            </div>

            <div className="space-y-12">
                {entries.map((entry, index) => (
                    <div key={entry.id} className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg">
                        <div className="bg-primary text-white px-6 py-3 flex justify-between items-center">
                            <span className="font-bold text-xs uppercase tracking-widest text-slate-200">Record Entry No: {index + 1}</span>
                            {entries.length > 1 && (
                                <button onClick={() => deleteEntry(entry.id)} className="text-[10px] bg-red-600 px-3 py-1 rounded hover:bg-red-700 font-bold uppercase transition">
                                    Remove Record
                                </button>
                            )}
                        </div>

                        <div className="p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {/* Columns 1-21 mapped directly from image */}
                            <FormField label="(1) S.No" value={entry.sNo} onChange={(v) => updateField(entry.id, 'sNo', v)} />
                            <FormField label="(2) Reference to entry in register of members" value={entry.refMembers} onChange={(v) => updateField(entry.id, 'refMembers', v)} />
                            <FormField label="(3) Name of the allottee" value={entry.allotteeName} onChange={(v) => updateField(entry.id, 'allotteeName', v)} />
                            
                            <FormField label="(4) Status of the allottee – whether director or employee" value={entry.allotteeStatus} onChange={(v) => updateField(entry.id, 'allotteeStatus', v)} />
                            <FormField label="(5) Date of passing of Board resolution" type="date" value={entry.boardResDate} onChange={(v) => updateField(entry.id, 'boardResDate', v)} />
                            <FormField label="(6) Date of the special resolution authorizing the issue of sweat equity shares" type="date" value={entry.specResDate} onChange={(v) => updateField(entry.id, 'specResDate', v)} />
                            
                            <FormField label="(7) Date of issue of sweat equity shares" type="date" value={entry.issueDate} onChange={(v) => updateField(entry.id, 'issueDate', v)} />
                            <FormField label="(8) Number of sweat equity shares issued" type="number" value={entry.numShares} onChange={(v) => updateField(entry.id, 'numShares', v)} />
                            <FormField label="(9) Certificate No. / Folio No." value={entry.certFolioNo} onChange={(v) => updateField(entry.id, 'certFolioNo', v)} />
                            
                            <FormField label="(10) Face value of the share" value={entry.faceValue} onChange={(v) => updateField(entry.id, 'faceValue', v)} />
                            <FormField label="(11) Price at which the shares are issued" value={entry.issuePrice} onChange={(v) => updateField(entry.id, 'issuePrice', v)} />
                            <FormField label="(12) Amount to be treated as paid up" value={entry.paidUpAmount} onChange={(v) => updateField(entry.id, 'paidUpAmount', v)} />

                            {/* Section for Consideration Paid (Columns 13-14) */}
                            <div className="p-4 border-2 border-slate-100 rounded-lg bg-slate-50/50 lg:col-span-2">
                                <label className="block text-[10px] font-black text-slate-400 uppercase mb-4">Total consideration paid, if any, by the employee / director</label>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <FormField label="(13) Consideration received in cash" value={entry.cashConsideration} onChange={(v) => updateField(entry.id, 'cashConsideration', v)} />
                                    <FormField label="(14) Particulars of consideration other than cash" type="description" value={entry.nonCashConsideration} onChange={(v) => updateField(entry.id, 'nonCashConsideration', v)} />
                                </div>
                            </div>

                            <FormField label="(15) Lock in period" value={entry.lockInPeriod} onChange={(v) => updateField(entry.id, 'lockInPeriod', v)} />
                            <FormField label="(16) Date of expiry of lock-in-period" type="date" value={entry.lockInExpiry} onChange={(v) => updateField(entry.id, 'lockInExpiry', v)} />
                            <FormField label="(17) Remarks, if any" type="description" value={entry.remarks} onChange={(v) => updateField(entry.id, 'remarks', v)} />
                            
                            <FormField label="(18) Date of Joining" type="date" value={entry.joiningDate} onChange={(v) => updateField(entry.id, 'joiningDate', v)} />
                            <FormField label="(19) Fair value obtained by Valuer" value={entry.fairValue} onChange={(v) => updateField(entry.id, 'fairValue', v)} />
                            <FormField label="(20) Basis of Valuation" type="description" value={entry.valuationBasis} onChange={(v) => updateField(entry.id, 'valuationBasis', v)} />
                            
                            <FormField label="(21) Name of Valuer" value={entry.valuerName} onChange={(v) => updateField(entry.id, 'valuerName', v)} />
                        </div>
                    </div>
                ))}
            </div>
            <Button 
            label='Add New SH-3 Register Entry'
                onClick={addEntry}
className="mt-2"            />
           
        </div>
    );
};

export default ShThreeForm;